import React from 'react';
import { Alert } from '@mui/material';

import type { UserType } from '@shared/auth/index.js';
import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

import { useAuth } from '../../../../../../hooks/index.js';
import { getUserTypeValidity, USER_TYPES } from '../../../../../../utils/index.js';
import { SingleDocumentListItem } from '../../../../../../components/DocumentManager';
import { usePatientIntakeStatusContext } from '../../../hooks';

const USERS_WITH_ACCESS_TO_REFERRAL_LETTER_OF_SUPPORT: UserType[] = [
  USER_TYPES.NURSE,
  USER_TYPES.DOCTOR,
  USER_TYPES.DIRECTOR,
];

type ReferralLetterOfSupportViewerProps = {
  step: IntakeStatusBaseSteps['UPLOAD_REFERRAL_LETTER_OF_SUPPORT'];
};

export const ReferralLetterOfSupportViewer: React.FC<ReferralLetterOfSupportViewerProps> = ({ step }) => {
  const { userType } = useAuth();
  const { patientId } = usePatientIntakeStatusContext();

  if (!step) {
    return null;
  }

  const { metadata } = step.currentStatus;

  if (!metadata) {
    return null;
  }

  const fileUploadDocId = metadata.fileUploadDocId;

  if (!fileUploadDocId) {
    return <Alert severity="info">No document has been uploaded for this step yet.</Alert>;
  }

  if (getUserTypeValidity({ userType, validUsers: USERS_WITH_ACCESS_TO_REFERRAL_LETTER_OF_SUPPORT })) {
    return <SingleDocumentListItem documentId={fileUploadDocId} patientId={patientId} type="PATIENT_DOCUMENT_UPLOAD" />;
  }

  return <Alert severity="info">The patient has uploaded a referral letter of support.</Alert>;
};
